module.exports = __webpack_public_path__ + "media/images/gallery/constellations/bootes/boo_pn-258130382a32aebdf866ef7e36ba86ca.gif";